/**
 * Web Components
 * Framework-agnostic components for page transitions
 */

// Ensure all components are registered
import './cap-router-outlet';
import './cap-page';
import './cap-header';
import './cap-content';
import './cap-footer';

export { CapRouterOutlet } from './cap-router-outlet';
export { CapPage } from './cap-page';
export { CapHeader } from './cap-header';
export { CapContent } from './cap-content';
export { CapFooter } from './cap-footer';
